import { defineStore } from 'pinia'
import type { ITemplateSettings } from '@ui/interfaces/templates'
import * as localStorage from '../helpers/local-storage'

export interface ITemplatesState {
  detail: ITemplateSettings | Object
}

function checkLocalStorage(scope: string = 'detail') {
  let obj: any = {}
  try {
    if (localStorage.getItem('useTemplates'))
      obj = JSON.parse(localStorage.getItem('useTemplates'))
  }
  catch (e) {}
  return obj && obj[scope] ? obj[scope] : {}
}

export const useTemplatesStore = defineStore('templates', {
  state: (): ITemplatesState => ({
    detail: checkLocalStorage('detail'),
  }),
  getters: {
    getDetail(): ITemplatesState['detail'] {
      return this.detail
    },
  },
  actions: {
    async setDetail(data: ITemplateSettings) {
      this.detail = data
    },
  },
})
